import {Fetch_All_Contact_Settings_Data, Update_Contact_Setting_Success,Clear_State} from '../action/contactSettingAction';
import {contactSettingState} from '../state/contactSettingState';

export function ContactSettingReducer(state = contactSettingState, action) {
    switch(action.type){
        case Fetch_All_Contact_Settings_Data:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                allSetting : action.allSetting
            })
        case Update_Contact_Setting_Success:
            return Object.assign({}, state, {
                errorCode : action.errorCode,
                statusCode : action.statusCode,
                message : action.message,
                responseValue : action.updatedValue
            })
        case Clear_State:
            return contactSettingState
        default:
            return state
    }
}